<template>
  <div class="batch-PDF-upload">
    <Uploader
      ref="uploader"
      id="batchUploader"
      :dropzoneOptions="singleDropzoneOptions"
      @uploadProgress="uploadProgress"
      @addFiles="addFiles"
      @uploadSuccess="uploadSuccess"
      @uploadError="uploadError"
      @canceled="uploadCanceled"
      @uploadComplete="uploadComplete"
      @uploadSending="uploadSending"
      @queueComplete="queueComplete"
    >
      <div class="button-upload"></div>
    </Uploader>
  </div>
</template>

<script>
import apis from '@api/login'
import Uploader from '@components/common/Uploader'
import { isIllegalWord } from '@/utils'
import { setEncryption } from '@/utils'
import { mapState } from 'vuex'
import statistics from '@components/books/statistics'
import compareVipRight from '@components/common/compareVipRight.js'

export default {
  name: 'batchPDFUpload',
  mixins: [statistics, compareVipRight],
  props: ['type', 'totalCount', 'pdfType', 'paperType'],
  data() {
    return {
      uploadState: 'ready',
      percentage: 0,
      filesMap: {}
    }
  },
  computed: {
    ...mapState('config', {
      open: (state) => state.bookObj.open,
      dpi: (state) => state.bookObj.dpi,
      referer: (state) => state.bookObj.referer,
      displayPageNo: (state) => state.bookObj.displayPageNo
    }),
    ...mapState('common', ['vipRight']),
    alreadyUse() {
      return this.$store.state.manage.alreadyUse || 0
    },
    totalSpace() {
      const space = this.$store.state.manage.allSpace
      if (space == 1) {
        return 1024
      } else {
        return space
      }
    },
    maxFilesize() {
      return this.vipRight.bookSize || 100
    },
    singleDropzoneOptions: {
      get() {
        const uploadBaseUrl = process.env.NODE_ENV === 'development' ? location.origin : window.PROJECT_CONFIG.BASE_URL
        let options = {
          url: uploadBaseUrl + '/ebook/batch/sliceUpload',
          thumbnailWidth: 150,
          maxFiles: 50,
          maxFilesize: this.maxFilesize, //单个文件
          headers: { Accept: 'application/json, text/plain, */*' },
          autoProcessQueue: false,
          chunking: true,
          chunkSize: 1024 * 1024,
          forceChunking: true,
          acceptedFiles: '.pdf,.PDF',
          duplicateCheck: true,
          timeout: 10000000000000000
        }
        return options
      }
    },
    userName() {
      return localStorage.getItem('username')
    },
    files: {
      get() {
        return this.$store.state.book.batchPDFFiles
      },
      set(value) {
        this.$store.commit('book/UPDATE_BATCH_FILES', value)
      }
    }
  },
  methods: {
    upload() {
      const browser = this.getBrowser()
      if (browser === 'QQ浏览器' || browser === 'Safari') {
        //qq浏览器 safari
        if (this.userName) {
          $('#batchUploader').click()
        } else {
          this.login()
        }
      } else {
        this.login()
      }
    },
    login() {
      apis.login().then((res) => {
        if (res && res.data && res.status === 200) {
          let data = res.data
          if (data.code === 101) {
            window.location.href = data.data
          } else {
            //QQ浏览器内不生效
            document.querySelector('#batchUploader').click()
          }
        }
      })
    },
    processFiles(files) {
      let res = []
      Object.values(files).forEach((item, index) => {
        this.filesMap[item.upload.uuid] = index
        res.push({ uuid: item.upload.uuid, name: item.name, percentage: 0, file: item })
      })
      return res
    },
    addFiles(files) {
      console.log('files', files)
      let sum = 0
      this.files = this.processFiles(files)
      this.$store.commit('book/UPDATE_BATCH_FILES', this.files)
      let l = files.length
      if (this.type === 'batch') {
        if (!this.compare({ type: 'num', key: 'bookNum', value: this.totalCount + l - 1 })) {
          this.$emit('toVip', 'num')
          return
        }
      }
      if (l > 50) {
        this.$alert('选择PDF数量不得超过50个', '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      for (let i = 0; i < l; i++) {
        sum += files[i].size
        if (isIllegalWord(files[i])) {
          this.$refs.uploader.cancelUpload()
          this.$alert('文件名中含有特殊字符，请重新上传', '提示', {
            confirmButtonText: '确定'
          })
          break
        } else if (files[i].size / (1024 * 1024) > this.vipRight.bookSize) {
          this.$alert(`PDF文件${files[i].name}大于${this.vipRight.bookSize}M，请重新上传`, '提示', {
            confirmButtonText: '确定'
          })
          break
        } else if (files[i].size / (1024 * 1024) + this.alreadyUse > this.totalSpace * 1024) {
          this.$emit('toSpace', 'batch')
        } else {
          if (i === l - 1) {
            // 合并上传相当于一个文件
            if (this.type === 'merge' && sum / (1024 * 1024) > this.vipRight.bookSize) {
              this.$alert(`上传PDF文件大于${this.vipRight.bookSize}M，请重新上传`, '提示', {
                confirmButtonText: '确定'
              })
            } else {
              this.$refs.uploader.processQueue()
              this.$emit('updateState', 'batchUploading')
            }
          }
        }
      }
    },
    uploadSending(file, xhr, formData) {
      formData.append('fileName', file.name)
      formData.append('dpi', this.dpi)
      formData.append('open', this.open)
      formData.append('referer', this.referer)
      formData.append('displayPageNo', this.displayPageNo)
      if (this.pdfType === 'paper') {
        formData.append('baozhiId', this.paperType)
      }
      console.log('sending', file, xhr, formData)
    },
    uploadSuccess(file, response) {
      console.log('success', file, this.files, response)
    },
    uploadComplete(file) {
      console.log('uploadComplete', file)
    },
    queueComplete() {
      console.log('queueComplete', this.files)
      let l = this.files.length
      for (let i = 0; i < l; i++) {
        if (this.files[i].file.status !== 'success') {
          break
        } else {
          if (i === l - 1) {
            this.$emit('updateState', 'done')
          }
        }
      }
    },
    uploadError(file, message, xhr) {
      console.log('error', file, message, xhr)
      // uploaderror Server responded with 0 code.
      // Upload canceled.

      if (message.startsWith('File is too big')) {
        if (this.type === 'batch') {
          this.$alert(`PDF文件${file.name}大于${this.vipRight.bookSize}M，请重新上传`, '提示', {
            confirmButtonText: '确定'
          })
        }
      } else if (message.startsWith("You can't upload files of this type")) {
        this.$alert('请上传pdf文件', '提示', {
          confirmButtonText: '确定'
        })
      } else if (message.startsWith('You can not upload any more files')) {
        // this.$alert('选择PDF数量不得超过50个', '提示', {
        //   confirmButtonText: '确定'
        // })
      } else if (message !== 'Upload canceled.') {
        this.$alert('文件传输中断，上传失败', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {
            if (action === 'confirm') {
              for (let i = 0; i < this.files.length; ) {
                if (this.files[i].file.status !== 'success') {
                  this.files.splice(i, 1)
                } else {
                  i++
                }
              }
            }
            this.queueComplete()
          }
        })
      }
    },
    uploadProgress(file, progress, bytesSent) {
      let percentage = Number(((bytesSent / file.size) * 100).toFixed(2))
      this.files[this.filesMap[file.upload.uuid]].percentage = percentage >= 100 ? 100 : percentage
      this.$emit('uploadProgress')
    },
    uploadCanceled(file) {
      console.log('cancel')
      this.$emit('updateState', 'ready')
      this.$emit('updateProgress', 0)
    },
    cancelRestore() {
      this.$refs.uploader.cancelUpload()
      this.$nextTick(() => {
        this.uploadCanceled()
      })
    }
  },
  components: {
    Uploader
  }
}
</script>
